import brokerUpstox from './resources/brand/broker-upstox.svg';
import broker5paisa from './resources/brand/broker-5paisa.png';
import brokerZerodha from './resources/brand/broker-zerodha.svg';
import brokerIifl from './resources/brand/broker-iifl.png';
import brokerFinvasia from './resources/brand/broker-finvasia.png';
import brokerBigul from './resources/brand/broker-bigul.png';
import brokerFyers from './resources/brand/broker-fyers.png';
import brokerTradejini from './resources/brand/broker-tradejini.png';
import brokerAcAgarwal from './resources/brand/broker-ac-agarwal.png';
import brokerBigulPro from './resources/brand/broker-bigul-pro.png';
import brokerJainamduck from './resources/brand/broker-jainamduck.png';
import brokerFlatTrade from './resources/brand/broker-flattrade.png';
import brokerKotak from './resources/brand/broker-kotak.png';
import brokerMotilalOswal from './resources/brand/broker-motilaloswal.png';
import brokerJainamXtsA from './resources/brand/broker-jainamxtsa.png';
import brokerCrkothari from './resources/brand/broker-crkothari.png';
import brokerMastertrustkambala from './resources/brand/broker-mastertrustkambala.png';
import brokerSharekhan from './resources/brand/broker-sharekhan.png';
import brokerTradejini2 from './resources/brand/broker-tradejini2.png';
import brokerAliceblue from './resources/brand/broker-aliceblue.png';
import brokerDhan from './resources/brand/broker-dhan.png';
import brokerIndiabulls from './resources/brand/broker-indiabulls.png';
import brokerNirmalbang from './resources/brand/broker-nirmalbang.png';
import brokerRikhav from './resources/brand/broker-rikhav.png';
import brokerAns from './resources/brand/broker-ans.png';
import brokerArham from './resources/brand/broker-arham.png';
import brokerShareindia from './resources/brand/broker-shareindia.png';
import brokerZebu from './resources/brand/broker-zebu.png';
import brokerFirstock from './resources/brand/broker-firstock.png';
import brokerGroww from './resources/brand/broker-groww.png';
import brokerRmoney from './resources/brand/broker-rmoney.png';
import brokerAngel from './resources/brand/broker-angel.png';
import brokerForwardTesting from './resources/brand/broker-forward-testing.png';
import usersTableStorage from './storage/users-table';
import adminsTableStorage from './storage/admins-table';
import topicsTableStorage from './storage/topics-table';
import couponsTableStorage from './storage/coupons-table';
import algoTableStorage from './storage/algo-table';
import manageInstanceTable from './storage/manage-instance-table';
import signupPageTableStorage from './storage/signup-page-table';
import notificationNonitoringTableStorage from './storage/notification-monitoring-table';
import announcementsTableStorage from './storage/announcement-table';

export const levels = [
  { label: 'ITM 15', value: 'ITM_15' },
  { label: 'ITM 14', value: 'ITM_14' },
  { label: 'ITM 13', value: 'ITM_13' },
  { label: 'ITM 12', value: 'ITM_12' },
  { label: 'ITM 11', value: 'ITM_11' },
  { label: 'ITM 10', value: 'ITM_10' },
  { label: 'ITM 9', value: 'ITM_9' },
  { label: 'ITM 8', value: 'ITM_8' },
  { label: 'ITM 7', value: 'ITM_7' },
  { label: 'ITM 6', value: 'ITM_6' },
  { label: 'ITM 5', value: 'ITM_5' },
  { label: 'ITM 4', value: 'ITM_4' },
  { label: 'ITM 3', value: 'ITM_3' },
  { label: 'ITM 2', value: 'ITM_2' },
  { label: 'ITM 1', value: 'ITM_1' },
  { label: 'ATM', value: 'ATM' },
  { label: 'OTM 1', value: 'OTM_1' },
  { label: 'OTM 2', value: 'OTM_2' },
  { label: 'OTM 3', value: 'OTM_3' },
  { label: 'OTM 4', value: 'OTM_4' },
  { label: 'OTM 5', value: 'OTM_5' },
  { label: 'OTM 6', value: 'OTM_6' },
  { label: 'OTM 7', value: 'OTM_7' },
  { label: 'OTM 8', value: 'OTM_8' },
  { label: 'OTM 9', value: 'OTM_9' },
  { label: 'OTM 10', value: 'OTM_10' },
  { label: 'OTM 11', value: 'OTM_11' },
  { label: 'OTM 12', value: 'OTM_12' },
  { label: 'OTM 13', value: 'OTM_13' },
  { label: 'OTM 14', value: 'OTM_14' },
  { label: 'OTM 15', value: 'OTM_15' },
];

export const brokers = {
  upstox: {
    img: brokerUpstox,
  },
  '5paisa': {
    img: broker5paisa,
  },
  zerodha: {
    img: brokerZerodha,
  },
  iifl: {
    img: brokerIifl,
  },
  angel: {
    img: brokerAngel,
  },
  finvasia: {
    img: brokerFinvasia,
  },
  bigul: {
    img: brokerBigul,
  },
  tradejini: {
    img: brokerTradejini,
  },
  fyers: {
    img: brokerFyers,
  },
  acagarwal: {
    img: brokerAcAgarwal,
  },
  'bigul-pro': {
    img: brokerBigulPro,
  },
  jainamduck: {
    img: brokerJainamduck,
  },
  flattrade: {
    img: brokerFlatTrade,
  },
  kotak: {
    img: brokerKotak,
  },
  motilaloswal: {
    img: brokerMotilalOswal,
  },
  iifl2: {
    img: brokerIifl,
  },
  'iifl-markets': {
    img: brokerIifl,
  },
  jainamxtsa: {
    img: brokerJainamXtsA,
  },
  jainamxtsb: {
    img: brokerJainamXtsA,
  },
  jainamxtsc: {
    img: brokerJainamXtsA,
  },
  jainamxtsd: {
    img: brokerJainamXtsA,
  },
  crkothari: {
    img: brokerCrkothari,
  },
  jainamsred: {
    img: brokerJainamXtsA,
  },
  jainamretail: {
    img: brokerJainamXtsA,
  },
  mastertrustkambala: {
    img: brokerMastertrustkambala,
  },
  sharekhan: {
    img: brokerSharekhan,
  },
  aliceblue: {
    img: brokerAliceblue,
  },
  tradejinicubeplus: {
    img: brokerTradejini2,
  },
  dhan: {
    img: brokerDhan,
  },
  'kotak-neo': {
    img: brokerKotak,
  },
  'kotak-neo-v2': {
    img: brokerKotak,
  },
  jainamdbd: {
    img: brokerJainamXtsA,
  },
  indiabulls: {
    img: brokerIndiabulls,
  },
  nirmalbang: {
    img: brokerNirmalbang,
  },
  rikhav: {
    img: brokerRikhav,
  },
  ans: {
    img: brokerAns,
  },
  arham: {
    img: brokerArham,
  },
  shareindia: {
    img: brokerShareindia,
  },
  'shareindia-pro-v6': {
    img: brokerShareindia,
  },
  zebu: {
    img: brokerZebu,
  },
  zebuxtsretail: {
    img: brokerZebu,
  },
  firstock: {
    img: brokerFirstock,
  },
  groww: {
    img: brokerGroww,
  },
  rmoney: {
    img: brokerRmoney,
  },
  'forward-testing': {
    img: brokerForwardTesting,
  },
  rikhavxtsretail: {
    img: brokerRikhav,
  },
};

export const userTypes = {
  admin: {
    title: 'Administrators',
    createPage: 'admin',
    addButtonText: 'New Administrator',
    deleteButtonText: 'Delete Administrator',
    deleteDialogTitle: 'Delete Administrator',
    deleteDialogSubText: 'Are you sure you want to delete',
    editLinkBase: 'admins',
    tableState: adminsTableStorage,
  },
  user: {
    title: 'Users',
    createPage: 'user',
    addButtonText: 'New User',
    deleteButtonText: 'Delete User',
    deleteDialogTitle: 'Delete User',
    deleteDialogSubText: 'Are you sure you want to delete',
    editLinkBase: 'users',
    tableState: usersTableStorage,
  },
  coupon: {
    title: 'Coupons',
    createPage: 'coupon',
    addButtonText: 'New Coupon',
    deleteButtonText: 'Delete Coupon',
    deleteDialogTitle: 'Delete Coupon',
    deleteDialogSubText: 'Are you sure you want to delete',
    editLinkBase: 'coupons',
    editTypes: {
      create: {
        pageTitle: 'New Coupon',
        classes: 'create create--coupon',
      },
      edit: {
        pageTitle: 'Edit Coupon',
        classes: 'edit-container edit-container__coupon',
      },
    },
    tableState: couponsTableStorage,
  },
  faqTopic: {
    title: 'Topics',
    createPage: 'document-topic',
    addButtonText: 'New Topic',
    editButtonText: 'Edit Topic',
    deleteButtonText: 'Delete Topic',
    deleteDialogTitle: 'Delete Topic',
    deleteDialogSubText: 'Are you sure you want to delete',
    editLinkBase: 'document-topics',
    tableState: topicsTableStorage,
  },
  faq: {
    title: 'Documents',
    createPage: 'document',
    addButtonText: 'New Sub topic',
    deleteButtonText: 'Delete Sub topic',
    deleteDialogTitle: 'Delete Sub topic',
    deleteDialogSubText: 'Are you sure you want to delete',
    editLinkBase: 'documents-list',
  },
  algo: {
    title: 'Algos',
    editLinkBase: 'algos',
    tableState: algoTableStorage,
  },
  manageInstance: {
    title: 'Manage Instance',
    createPage: 'manageInstance',
    tableState: manageInstanceTable,
  },
  announcement: {
    title: 'In-app Announcements',
    createPage: 'in-app-announcements',
    addButtonText: 'New Announcement',
    deleteButtonText: 'Delete Announcement',
    deleteDialogTitle: 'Delete Announcement',
    deleteDialogSubText: 'Are you sure you want to delete',
    editLinkBase: 'announcements/in-app-announcements',
    tableState: announcementsTableStorage,
  },
  signupPage: {
    title: 'Signup Pages',
    createPage: 'signup-page',
    addButtonText: 'New Signup page',
    deleteButtonText: 'Delete Signup page',
    deleteDialogTitle: 'Delete Signup page',
    deleteDialogSubText: 'Are you sure you want to delete',
    editLinkBase: 'signup-pages',
    editTypes: {
      create: {
        pageTitle: 'New Signup page',
        classes: 'create create--signup-page',
      },
      edit: {
        pageTitle: 'Edit Signup page',
        classes: 'edit-container edit-container__signup-page',
      },
    },
    tableState: signupPageTableStorage,
  },
  notificationMonitoring: {
    title: 'Notification Monitoring',
    deleteButtonText: 'Delete Notification',
    deleteDialogTitle: 'Delete Notification',
    deleteDialogSubText: 'Are you sure you want to delete',
    tableState: notificationNonitoringTableStorage,
  },
};

export const tradingDays = [
  {
    id: 'MON',
    name: 'Monday',
    shortName: 'Mon',
  },
  {
    id: 'TUE',
    name: 'Tuesday',
    shortName: 'Tue',
  },
  {
    id: 'WED',
    name: 'Wednesday',
    shortName: 'Wed',
  },
  {
    id: 'THU',
    name: 'Thursday',
    shortName: 'Thu',
  },
  {
    id: 'FRI',
    name: 'Friday',
    shortName: 'Fri',
  },
  {
    id: 'SAT',
    name: 'Saturday',
    shortName: 'Sat',
  },
  {
    id: 'SUN',
    name: 'Sunday',
    shortName: 'Sun',
  },
];

export const productTypesUpstox = {
  I: 'intraday',
  D: 'delivery',
  CO: 'cover order',
  OCO: 'One cancels other',
};

export const algoTypes = {
  OPTIONS_SPREADS_LEGS: 'Option Spreads: Legs',
  OPTIONS_SPREADS_PREMIUM_MATCHING: 'Option Spreads: Premium Matching',
  OPTIONS_SPREADS_STRIKES: 'Option Spreads: Strikes',
};
